import Login from "views/Public/Login";
import NotCompatible from "views/Public/NotCompatible";

const routes = [
  {
    path: "/device-not-compatible/*",
    name: "NotCompatible",
    element: <NotCompatible />,
  },
  {
    path: "/login/*",
    name: "LoginAndRegistration",
    element: <Login />,
  },
  {
    path: "/*",
    name: "Login",
    element: <Login />,
  },
];

export default routes;
